import { buildProps } from '@sgui-plus/utils/props'
import { UPDATE_MODEL_EVENT } from '@sgui-plus/utils/constants'
import { useTooltipContentProps } from '@sgui-plus/components/tooltip'
import type {PropType} from 'vue'

export declare interface TreeNodeData {
  [key:string]:any
}

export declare interface TreeOptionProps {
  value: any
  children?:string,
  label?:string
  disabled?:string
}

export declare interface TreeComponentProps{
  props: TreeOptionProps
}

export const combotreeProps = buildProps({
  data: {
    type: Array,
    default: () => []
  },
  filterable: {
    type: Boolean,
    default: false
  },
  nodeKey: {
    type: String
  },
  multiple: {
    type: Boolean,
    default: false
  },
  readonly: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  cascadeCheck: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: [Array, String, Number],
    default: undefined
  },
  size: {
    type: String,
    default: 'default'
  },
  // 是否可输入
  allowCreate: Boolean,
  // 是否可清空
  clearable: Boolean,
  // 只选择子节点
  justChildNodes:  Boolean,
  // 只选择父节点
  justParentNodes: Boolean,
  // 是否将下拉列表插入至body
  transfer: useTooltipContentProps.transfer,
  // 下拉列表位置
  placement: {
    type: String,
    default: 'bottom',
  },
  // 下拉框宽度
  dropWidth: {
    type: [String, Number]
  },
  // 下拉框高度
  dropHeight: {
    type: [String, Number],
    default: 200
  },
  // 默认文字
  placeholder: {
    type: String,
    default: ''
  },
  // 是否高亮搜索关键词
  filterHighlight: {
    type: Boolean,
    default: true
  },
  filterPlaceholder: {
    type: String,
    default: ''
  },
  // 多选时，选择框是否固定高度
  fixedHeight: Boolean,
  // 多选时，是否以数字标签(eg:+2)的展示效果
  collapseTags: {
    type: Boolean,
    default: false,
  },
  // 多选时，是否以省略标签(eg:...)的展示效果
  ellipsisTag: {
    type: Boolean,
    default: false,
  },
  // 是否用Tooltip展示省略的已选值
  showMultipleTip: {
    type: Boolean,
    default: false,
  },
  multipleTipTransfer: {
    type: Boolean,
    default: false
  },
  // Tooltip的偏移位置
  toolTipOffset: {
    type: Number,
    default: 0
  },
  // Tooltip的主题配置
  toolTipTheme: {
    type: String as PropType<'light' | 'dark' | string>,
    default: 'light',
  },
  // 省略标签时是否只显示首项
  notOnlyOne: {
    type: Boolean,
    default: false,
  },
  // 是否显示图标
  showIcon: {
    type: Boolean,
    default: true
  },
  props: {
    type: Object as PropType<TreeComponentProps['props']>,
    default: () => ({
      label: 'label',
      value: 'value',
      children: 'children'
    })
  }
})

export const combotreeEmits = {
  [UPDATE_MODEL_EVENT]: (value: any) => true,
  onNodeClick: (node: TreeNodeData) => true,
  onCheckChange: (node: TreeNodeData, checked: boolean) => typeof checked === 'boolean',
  onChange: (value: any) => true,
  onVisibleChange: (value: boolean) => typeof value === 'boolean',
  onRemove: (tag: string) => true,
  onClear: () => true
}

export type ComboTreeEmits = typeof combotreeEmits
